package com.narbase.letsgo.web.common

import com.narbase.kunafa.core.dimensions.px

object AppFontSizes {
    val largeTitle = 30.px
    val titleText = 24.px
    val subtitle = 16.px
    val mainListTitle = 18.px
    val mainListSubtitle = 16.px
    val sideListTitle = 15.px
    val sideListSubtitle = 13.px
    val largeButtonText = 16.px
    val normalButtonSize = 14.px
    val smallButtonSize = 12.px
    val notificationIconText = 8.px
    val extraSmallText = 10.px
    val smallerText = 12.px
    val smallText = 14.px
    val normalText = 16.px
    val largeText = 18.px
    val largerText = 20.px
}
